<template>
  <div>
    <b-card>
      <page-title v-if="titleStatus" :title="$t('horseGenders.items')" />

      <main-table
        :fields="fields"
        :list_url="'admin/horse-sex'"
        :reloadData="reloadData"
        :params="filter"
        :createBtnLabel="$t('horseGenders.create')"
        createRouteName="contributor.horseGenderCreate"
        :excelFields="excelFields"
        excelName="horseGenders"
        :downloadSampleStatus="true"
        downloadSampleUrl="horse-sex/excel-sample"
        :uploadFileStatus="true"
        uploadFileUrl="horse-sex/excel"
      />
    </b-card>
  </div>
</template>
<script>
import { core } from "../../../../config/pluginInit";
import HorseGenderFilter from "../models/HorseGenderFilter";
import searchMixin from "../../../../Mixins/searchMixin";

export default {
  mixins: [searchMixin],
  data() {
    return {
      filter: new HorseGenderFilter(),
      fields: [
        this.$t("global.selected"),
        { key: "id", label: this.$t("table.id"), sortable: true },
        { key: "name", label: this.$t("table.name"), sortable: true },
        {
          key: "actions",
          label: this.$t("table.actions"),
          type: "actions",
          actions: [
            {
              text: this.$t("global.view"),
              icon: "fas fa-eye",
              color: "info",
              ifNavigate: true,
              routeName: "contributor.horseGenderView",
              routeParams: ["id"],
            },
            {
              text: this.$t("global.update"),
              icon: "fas fa-pen",
              color: "primary",
              ifNavigate: true,
              routeName: "contributor.horseGenderUpdate",
              routeParams: ["id"],
            },
            {
              text: this.$t("global.delete"),
              icon: "fas fa-trash-alt",
              color: "danger",
              showAlert: true,
              actionHeader: this.$t("global.delete"),
              titleHeader: this.$t("horseGenders.item"),
              textContent: "name",
              url: "admin/horse-sex",
              type: "delete",
            },
          ],
        },
      ],
      excelFields: {
        [this.$t("table.id")]: "id",
        [this.$t("table.name")]: "name",
        [this.$t("table.createdAt")]: "created_at",
      },
    };
  },
  mounted() {
    core.index();
  },
};
</script>
